import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';

export type ResellerLanguageOrg = {
  organization_id: number;
  organization_name: string;
  is_reseller_root: boolean;
  publication_id: number | null;
};

export type ResellerLanguagePublication = {
  language_id: number;
  language_name: string;
  language_key: string;
  organizations: ResellerLanguageOrg[];
};

export type ResellerLanguagePublicationsResponse = BaseResponse<
  ResellerLanguagePublication[]
>;

export const RESELLER_LANGUAGE_PUBLICATIONS_QUERY_KEY =
  'resellerLanguagePublications';

export const useGetResellerLanguagePublications = () => {
  const fetchLanguagePublications = async () => {
    const { resellerLanguagePublications } = GET_URL();
    const { data } = await Axios.get<ResellerLanguagePublicationsResponse>(
      resellerLanguagePublications
    );
    return data;
  };

  return useQuery<
    ResellerLanguagePublicationsResponse,
    AxiosError<BaseError>,
    ResellerLanguagePublication[]
  >([RESELLER_LANGUAGE_PUBLICATIONS_QUERY_KEY], fetchLanguagePublications, {
    useErrorBoundary: false,
    select: data => {
      const r = data?.result;
      return Array.isArray(r) ? r : [];
    }
  });
};
